


import React, { useState, useEffect, useRef } from 'react';
import {
    FaSearch, FaSpinner, FaTimes,
    FaChevronDown, FaChevronUp,
    FaClipboardList, FaCheckCircle, FaClock,
    FaBuilding, FaMapMarkerAlt, FaReceipt,
    FaCheck, FaCalendarAlt, FaUsers, FaMoneyBillWave
} from 'react-icons/fa';
import { getAllEnquiries, acceptQuotation, getAllPayments } from '../../../Servicefile/salesService';
import axios from 'axios';

const ManagerQuotation = () => {
    // ============================================
    // STATE
    // ============================================
    const [enquiries, setEnquiries] = useState([]);
    const [filteredEnquiries, setFilteredEnquiries] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingQuotations, setLoadingQuotations] = useState(false);
    const [acceptingQuotation, setAcceptingQuotation] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [expandedId, setExpandedId] = useState(null);
    const [quotationsMap, setQuotationsMap] = useState({});
    const [expandedQuotation, setExpandedQuotation] = useState(null);
    const [hoveredCard, setHoveredCard] = useState(null);
    const [acceptedQuotations, setAcceptedQuotations] = useState({});

    // ─── PAYMENTS STATE ──────────────────────────────────────────
    const [paymentsMap, setPaymentsMap] = useState({});
    const [loadingPayments, setLoadingPayments] = useState(false);

    // ============================================
    // DATE FILTER STATE
    // ============================================
    const [dateFilter, setDateFilter] = useState('All');
    const [customFromDate, setCustomFromDate] = useState('');
    const [customToDate, setCustomToDate] = useState('');
    const [showCustomPopup, setShowCustomPopup] = useState(false);
    const dateFilterRef = useRef(null);

    // Stats
    const [stats, setStats] = useState({
        total: 0,
        quoted: 0,
        pending: 0
    });

    // ============================================
    // API CALLS
    // ============================================
    const fetchQuotations = async () => {
        setLoading(true);
        try {
            const data = await getAllEnquiries();

            const quotedData = (data || []).filter(enquiry =>
                enquiry.adminId !== null &&
                enquiry.adminId !== undefined &&
                enquiry.leadStatus === 'PAYMENT_RECEIVED'
            );

            const sortedData = quotedData.sort((a, b) => {
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);
                return dateB - dateA;
            });

            setEnquiries(sortedData);
            setFilteredEnquiries(sortedData);
            calculateStats(sortedData);

            // Fetch payments for all leads
            await fetchAllPayments(sortedData);
        } catch (error) {
            console.error('Error fetching quotations:', error);
            alert('Failed to fetch quotations');
        } finally {
            setLoading(false);
        }
    };

    // ─── FETCH ALL PAYMENTS ──────────────────────────────────────
    const fetchAllPayments = async (enquiriesData) => {
        setLoadingPayments(true);
        try {
            const payments = await getAllPayments();

            // Group payments by leadId
            const groupedPayments = {};
            payments.forEach(payment => {
                if (!groupedPayments[payment.leadId]) {
                    groupedPayments[payment.leadId] = [];
                }
                groupedPayments[payment.leadId].push(payment);
            });

            setPaymentsMap(groupedPayments);
        } catch (error) {
            console.error('Error fetching payments:', error);
        } finally {
            setLoadingPayments(false);
        }
    };

    const fetchQuotationsByLeadId = async (leadId) => {
        if (quotationsMap[leadId]) {
            return;
        }

        setLoadingQuotations(true);
        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(
                `https://backend.maamaas.com/catering/api/user/lead/quotations/${leadId}/`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            if (response.data.success) {
                setQuotationsMap(prev => ({
                    ...prev,
                    [leadId]: response.data.data || []
                }));
            } else {
                setQuotationsMap(prev => ({
                    ...prev,
                    [leadId]: []
                }));
            }
        } catch (error) {
            console.error('Error fetching quotations:', error);
            setQuotationsMap(prev => ({
                ...prev,
                [leadId]: []
            }));
        } finally {
            setLoadingQuotations(false);
        }
    };

    // ============================================
    // ACCEPT QUOTATION API
    // ============================================
    const checkTokenDebug = () => {
        const token = localStorage.getItem("authToken");
     

        return token;
    };

    const handleAcceptQuotation = async (quotationId, vendorName) => {
        if (!window.confirm(`Are you sure you want to accept the quotation from ${vendorName}?`)) {
            return;
        }

        const token = checkTokenDebug();
        if (!token) {
            alert("❌ No authentication token found. Please login again.");
            return;
        }

        setAcceptingQuotation(true);
        try {
            const response = await acceptQuotation(quotationId);

            if (response.success) {
                setAcceptedQuotations(prev => ({
                    ...prev,
                    [quotationId]: true
                }));

                alert(`✅ Quotation from ${vendorName} has been accepted successfully!`);

                const leadId = Object.keys(quotationsMap).find(key =>
                    quotationsMap[key].some(q => q.quotationId === quotationId)
                );
                if (leadId) {
                    setQuotationsMap(prev => {
                        const newMap = { ...prev };
                        delete newMap[leadId];
                        return newMap;
                    });
                    fetchQuotationsByLeadId(leadId);
                }
            } else {
                alert(response.message || 'Failed to accept quotation');
            }
        } catch (error) {
            console.error('Error accepting quotation:', error);
            alert('Failed to accept quotation. Please try again.');
        } finally {
            setAcceptingQuotation(false);
        }
    };

  

    // ============================================
    // CALCULATE STATS
    // ============================================
    const calculateStats = (data) => {
        const total = data.length;
        const quoted = data.filter(e => e.leadStatus === 'PAYMENT_RECEIVED').length;
        const pending = data.filter(e => e.leadStatus !== 'PAYMENT_RECEIVED').length;
        setStats({ total, quoted, pending });
    };

    // ============================================
    // FILTER & SEARCH LOGIC
    // ============================================

    const getDateRange = (filter) => {
        const today = new Date();
        let fromDate = null;
        let toDate = null;

        switch (filter) {
            case 'All':
                return null;
            case 'Today':
                fromDate = today;
                toDate = today;
                break;
            case 'Yesterday':
                const yesterday = new Date(today);
                yesterday.setDate(today.getDate() - 1);
                fromDate = yesterday;
                toDate = yesterday;
                break;
            case 'This Week':
                const day = today.getDay();
                const diff = today.getDate() - day + (day === 0 ? -6 : 1);
                const monday = new Date(today.setDate(diff));
                const sunday = new Date(today);
                sunday.setDate(monday.getDate() + 6);
                fromDate = monday;
                toDate = sunday;
                break;
            case 'Custom Range':
                if (customFromDate && customToDate) {
                    fromDate = new Date(customFromDate);
                    toDate = new Date(customToDate);
                }
                break;
            default:
                return null;
        }
        return { fromDate, toDate };
    };

    const applyFilters = () => {
        let filtered = [...enquiries];
        const range = getDateRange(dateFilter);

        if (range) {
            const from = new Date(range.fromDate);
            from.setHours(0, 0, 0, 0);
            const to = new Date(range.toDate);
            to.setHours(23, 59, 59, 999);

            filtered = filtered.filter(enquiry => {
                if (!enquiry.createdAt) return false;
                const leadDate = new Date(enquiry.createdAt);
                return leadDate >= from && leadDate <= to;
            });
        }

        if (searchTerm.trim() !== '') {
            const term = searchTerm.toLowerCase();
            filtered = filtered.filter(enquiry =>
                (enquiry.fullName || '').toLowerCase().includes(term) ||
                (enquiry.email || '').toLowerCase().includes(term) ||
                (enquiry.companyName || '').toLowerCase().includes(term) ||
                (enquiry.city || '').toLowerCase().includes(term) ||
                (enquiry.enquiryId || enquiry.id || '').toString().includes(term)
            );
        }

        setFilteredEnquiries(filtered);
    };

    useEffect(() => {
        applyFilters();
    }, [searchTerm, dateFilter, customFromDate, customToDate]);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const clearSearch = () => {
        setSearchTerm('');
        setDateFilter('All');
        setCustomFromDate('');
        setCustomToDate('');
        setShowCustomPopup(false);
    };

    const handleDateFilterChange = (e) => {
        const value = e.target.value;
        setDateFilter(value);
        if (value === 'Custom Range') {
            setShowCustomPopup(true);
        } else {
            setShowCustomPopup(false);
            setCustomFromDate('');
            setCustomToDate('');
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dateFilterRef.current && !dateFilterRef.current.contains(event.target)) {
                setShowCustomPopup(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // ============================================
    // TOGGLE EXPAND
    // ============================================
    const toggleExpand = (leadId) => {
        if (expandedId === leadId) {
            setExpandedId(null);
            setExpandedQuotation(null);
        } else {
            setExpandedId(leadId);
            setExpandedQuotation(null);
            fetchQuotationsByLeadId(leadId);
        }
    };

    const toggleQuotationExpand = (quotationId) => {
        setExpandedQuotation(expandedQuotation === quotationId ? null : quotationId);
    };

    // ============================================
    // FORMAT HELPERS
    // ============================================
    const formatDate = (dateStr) => {
        if (!dateStr) return '-';
        try {
            const date = new Date(dateStr);
            return date.toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        } catch {
            return dateStr;
        }
    };

    const formatCurrency = (amount) => {
        if (!amount) return '₹0';
        return `₹${Number(amount).toLocaleString('en-IN')}`;
    };

    const getStatusBadge = (status) => {
        if (status === 'PAYMENT_RECEIVED') {
            return (
                <span style={{ ...badgeBaseStyle, background: '#E8F5EC', color: '#1E7A3D' }}>
                    <FaCheckCircle size={11} /> Quoted
                </span>
            );
        }
        return (
            <span style={{ ...badgeBaseStyle, background: '#FDF1E1', color: '#B5720F' }}>
                <FaClock size={11} /> Pending
            </span>
        );
    };

    const getQuotationStatusBadge = (status) => {
        const statusMap = {
            'SUBMITTED': { bg: '#E4EEFB', color: '#20579B', label: 'Submitted' },
            'APPROVED': { bg: '#E8F5EC', color: '#1E7A3D', label: 'Approved' },
            'REJECTED': { bg: '#FBEAE7', color: '#B5402C', label: 'Rejected' },
            'PENDING': { bg: '#FDF1E1', color: '#B5720F', label: 'Pending' }
        };
        const info = statusMap[status] || statusMap['PENDING'];
        return (
            <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '3px 10px',
                borderRadius: '20px',
                fontSize: '11px',
                fontWeight: 600,
                letterSpacing: '0.2px',
                background: info.bg,
                color: info.color
            }}>
                {info.label}
            </span>
        );
    };

    // ============================================
    // GET PAYMENT INFO FOR LEAD
    // ============================================
    const getPaymentInfo = (leadId) => {
        const payments = paymentsMap[leadId] || [];
        const vendorCount = new Set(payments.map(p => p.vendorId)).size;
        const totalAmount = payments.reduce((sum, p) => sum + (p.paymentAmount || 0), 0);
        return { vendorCount, totalAmount, payments };
    };

    // ============================================
    // EFFECTS
    // ============================================
    useEffect(() => {
        fetchQuotations();
    }, []);

    // ============================================
    // RENDER
    // ============================================
    return (
        <div style={containerStyle}>
            <style>{globalCss}</style>

            {/* Stats Cards */}
            <div className="stats-container" style={statsContainerStyle}>
                <div className="stat-card" style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#FBEDE4', color: '#C1552A' }}>
                        <FaClipboardList size={18} />
                    </div>
                    <div>
                        <div className="stat-number" style={statNumberStyle}>{stats.total}</div>
                        <div style={statLabelStyle}>Total Quoted</div>
                    </div>
                </div>
                <div className="stat-card" style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#E8F5EC', color: '#1E7A3D' }}>
                        <FaCheckCircle size={18} />
                    </div>
                    <div>
                        <div className="stat-number" style={statNumberStyle}>{stats.quoted}</div>
                        <div style={statLabelStyle}>Quoted</div>
                    </div>
                </div>
                <div className="stat-card" style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#FDF1E1', color: '#B5720F' }}>
                        <FaClock size={18} />
                    </div>
                    <div>
                        <div className="stat-number" style={statNumberStyle}>{stats.pending}</div>
                        <div style={statLabelStyle}>Pending</div>
                    </div>
                </div>
            </div>

            {/* Search & Date Filter Container */}
            <div className="search-filter-container" style={searchFilterContainerStyle}>

                {/* Search Bar */}
                <div className="search-container" style={searchContainerStyle}>
                    <FaSearch style={searchIconStyle} size={14} />
                    <input
                        type="text"
                        placeholder="Search by name, email, company, city..."
                        value={searchTerm}
                        onChange={handleSearch}
                        style={searchInputStyle}
                    />
                    {searchTerm && (
                        <button onClick={clearSearch} style={clearSearchButtonStyle}>
                            <FaTimes size={13} />
                        </button>
                    )}
                </div>

                {/* Date Filter */}
                <div ref={dateFilterRef} style={{ position: 'relative' }}>
                    <div style={dateFilterWrapperStyle}>
                        <FaCalendarAlt size={13} style={{ color: '#8C7F6E', marginRight: '6px' }} />
                        <select
                            value={dateFilter}
                            onChange={handleDateFilterChange}
                            style={dateDropdownStyle}
                        >
                            <option value="All">All Leads</option>
                            <option value="Today">Today</option>
                            <option value="Yesterday">Yesterday</option>
                            <option value="This Week">This Week</option>
                            <option value="Custom Range">Custom Range</option>
                        </select>
                    </div>

                    {showCustomPopup && (
                        <div style={customPopupStyle}>
                            <div style={customPopupHeaderStyle}>
                                <span style={{ fontWeight: 600, fontSize: '13px' }}>Select Date Range</span>
                                <button
                                    onClick={() => setShowCustomPopup(false)}
                                    style={popupCloseBtnStyle}
                                >
                                    <FaTimes size={12} />
                                </button>
                            </div>
                            <div style={customPopupBodyStyle}>
                                <div style={customInputGroupStyle}>
                                    <label style={customLabelStyle}>From</label>
                                    <input
                                        type="date"
                                        value={customFromDate}
                                        onChange={(e) => setCustomFromDate(e.target.value)}
                                        style={customDateInputStyle}
                                    />
                                </div>
                                <div style={customInputGroupStyle}>
                                    <label style={customLabelStyle}>To</label>
                                    <input
                                        type="date"
                                        value={customToDate}
                                        onChange={(e) => setCustomToDate(e.target.value)}
                                        style={customDateInputStyle}
                                    />
                                </div>
                                <button
                                    onClick={() => setShowCustomPopup(false)}
                                    style={popupApplyBtnStyle}
                                >
                                    Apply
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                <div style={resultCountStyle}>
                    {filteredEnquiries.length} result{filteredEnquiries.length !== 1 && 's'}
                </div>
            </div>

            {/* Lead Cards */}
            <div style={cardsContainerStyle}>
                {loading ? (
                    <div style={loadingStyle}>
                        <FaSpinner className="spin" size={28} color="#C1552A" />
                        <p>Loading quotations...</p>
                    </div>
                ) : filteredEnquiries.length === 0 ? (
                    <div style={emptyStateStyle}>
                        <div style={emptyStateContentStyle}>
                            <FaClipboardList size={40} color="#D9CFC2" />
                            <p style={emptyStateTextStyle}>No quotations found</p>
                            <span style={emptyStateSubtextStyle}>
                                {searchTerm || dateFilter !== 'All' ? 'Try adjusting your search or date filters' : 'No enquiries with quotations available'}
                            </span>
                        </div>
                    </div>
                ) : (
                    filteredEnquiries.map((enquiry) => {
                        const leadId = enquiry.id || enquiry.enquiryId;
                        const isExpanded = expandedId === leadId;
                        const leadQuotations = quotationsMap[leadId] || [];
                        const isLoadingQuotations = loadingQuotations && isExpanded && !quotationsMap[leadId];

                        // Get payment info for this lead
                        const paymentInfo = getPaymentInfo(leadId);
                        const hasPayments = paymentInfo.vendorCount > 0;

                        return (
                            <div key={leadId} style={cardWrapperStyle}>
                                <div
                                    style={{
                                        ...cardOuterStyle,
                                        borderColor: isExpanded ? '#E9A277' : '#EDE6DB',
                                        boxShadow: isExpanded
                                            ? '0 8px 24px rgba(198, 106, 55, 0.12)'
                                            : hoveredCard === leadId
                                                ? '0 4px 14px rgba(31, 22, 15, 0.07)'
                                                : '0 1px 2px rgba(31, 22, 15, 0.04)'
                                    }}
                                    onMouseEnter={() => setHoveredCard(leadId)}
                                    onMouseLeave={() => setHoveredCard(null)}
                                >
                                    {/* Card Header */}
                                    <div
                                        className="card-header"
                                        style={cardHeaderStyle}
                                        onClick={() => toggleExpand(leadId)}
                                    >
                                        <div style={{ ...leadAccentStyle, background: enquiry.leadStatus === 'PAYMENT_RECEIVED' ? '#2F9E5B' : '#E0972B' }} />
                                        <div style={cardHeaderLeftStyle}>
                                            <div style={avatarStyle}>
                                                {(enquiry.fullName || '?')[0].toUpperCase()}
                                            </div>
                                            <div style={{ minWidth: 0 }}>
                                                <div className="customer-name" style={customerNameStyle}>{enquiry.fullName || 'Unknown'}</div>
                                                <div style={customerDetailStyle}>
                                                    {enquiry.companyName || 'No company'}
                                                    <span style={dotSeparatorStyle}>•</span>
                                                    <FaMapMarkerAlt size={10} style={{ marginRight: '3px', opacity: 0.6 }} />
                                                    {enquiry.city || 'No city'}
                                                </div>
                                            </div>
                                        </div>
                                        <div style={paymentInfoContainerStyle}>
                                            <div style={paymentInfoRowStyle}>
                                                <span style={paymentInfoLabelStyle}>
                                                    <FaUsers size={12} style={{ marginRight: '6px' }} />
                                                    Vendors Bought:
                                                </span>
                                                <span style={paymentInfoValueStyle}>{paymentInfo.vendorCount}</span>
                                            </div> 
                                            <div style={paymentInfoRowStyle}>
                                                <span style={paymentInfoLabelStyle}>
                                                    <FaMoneyBillWave size={12} style={{ marginRight: '6px' }} />
                                                    Total Money Earned :
                                                </span>
                                                <span style={paymentInfoValueStyle}>{formatCurrency(paymentInfo.totalAmount)}</span>
                                            </div>
                                        </div>
                                        <div className="card-header-right" style={cardHeaderRightStyle}>
                                            <div className="amount" style={amountStyle}>{formatCurrency(enquiry.budget)}</div>
                                            {getStatusBadge(enquiry.leadStatus)}
                                            <div style={{ ...expandIconStyle, transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                                                <FaChevronDown size={13} />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Payment Info - Displayed below header when expanded */}
                                    {/* {isExpanded && hasPayments && (
                                        <div style={paymentInfoContainerStyle}>
                                            <div style={paymentInfoRowStyle}>
                                                <span style={paymentInfoLabelStyle}>
                                                    <FaUsers size={12} style={{ marginRight: '6px' }} />
                                                    Vendors Bought:
                                                </span>
                                                <span style={paymentInfoValueStyle}>{paymentInfo.vendorCount}</span>
                                            </div>
                                            <div style={paymentInfoRowStyle}>
                                                <span style={paymentInfoLabelStyle}>
                                                    <FaMoneyBillWave size={12} style={{ marginRight: '6px' }} />
                                                    Total Money Received:
                                                </span>
                                                <span style={paymentInfoValueStyle}>{formatCurrency(paymentInfo.totalAmount)}</span>
                                            </div>
                                        </div>
                                    )} */}

                                    {/* Card Body */}
                                    {isExpanded && (
                                        <div className="card-body" style={cardBodyStyle}>
                                            <div style={bodyLabelStyle}>Vendor Bids</div>
                                            {isLoadingQuotations ? (
                                                <div style={loadingQuotationsStyle}>
                                                    <FaSpinner className="spin" size={22} color="#C1552A" />
                                                    <p>Fetching vendor quotations...</p>
                                                </div>
                                            ) : leadQuotations.length === 0 ? (
                                                <div style={noQuotationsStyle}>
                                                    No quotations submitted for this lead yet
                                                </div>
                                            ) : (
                                                <div style={quotationsListStyle}>
                                                    {leadQuotations.map((quotation, index) => {
                                                        const qId = quotation.quotationId || index;
                                                        const qExpanded = expandedQuotation === qId;
                                                        const isAccepted = acceptedQuotations[qId];

                                                        return (
                                                            <div key={qId} style={{
                                                                ...quotationCardStyle,
                                                                borderColor: isAccepted ? '#2F9E5B' : (qExpanded ? '#E9A277' : '#EDE6DB'),
                                                                borderWidth: isAccepted ? '2px' : '1px',
                                                            }}>
                                                                <div
                                                                    className="quotation-header"
                                                                    style={quotationHeaderStyle}
                                                                    onClick={() => toggleQuotationExpand(qId)}
                                                                >
                                                                    <div style={quotationHeaderLeftStyle}>
                                                                        <div style={vendorIconStyle}>
                                                                            <FaBuilding size={14} />
                                                                        </div>
                                                                        <div>
                                                                            <div style={vendorNameStyle}>
                                                                                {quotation.vendorName || 'Unknown Vendor'}
                                                                                {isAccepted && (
                                                                                    <span style={{
                                                                                        marginLeft: '8px',
                                                                                        fontSize: '11px',
                                                                                        fontWeight: 700,
                                                                                        color: '#1E7A3D',
                                                                                        background: '#E8F5EC',
                                                                                        padding: '2px 10px',
                                                                                        borderRadius: '12px'
                                                                                    }}>
                                                                                        ✅ Accepted
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                            <div style={quotationMetaStyle}>
                                                                                {getQuotationStatusBadge(quotation.status)}
                                                                                <span style={quotationDateStyle}>
                                                                                    {formatDate(quotation.createdAt)}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="quotation-header-right" style={quotationHeaderRightStyle}>
                                                                        <div style={quotedAmountStyle}>{formatCurrency(quotation.quotedAmount)}</div>
                                                                        <div style={{ ...expandIconStyle, transform: qExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                                                                            <FaChevronDown size={12} />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* Quotation Detail */}
                                                                {qExpanded && (
                                                                    <div style={quotationDetailWrapStyle}>
                                                                        <div style={perforationStyle}>
                                                                            {Array.from({ length: 40 }).map((_, i) => (
                                                                                <span key={i} style={perfDotStyle} />
                                                                            ))}
                                                                        </div>
                                                                        <div className="quotation-grid" style={quotationGridStyle}>
                                                                            <InvoiceSection title="Pricing">
                                                                                <DetailRow label="Base amount" value={formatCurrency(quotation.baseAmount)} />
                                                                                <DetailRow label="Veg / plate" value={formatCurrency(quotation.vegPerPlatePrice)} />
                                                                                <DetailRow label="Non-veg / plate" value={formatCurrency(quotation.nonVegPerPlatePrice)} />
                                                                                <DetailRow label="Mixed / plate" value={formatCurrency(quotation.mixedPerPlatePrice)} />
                                                                                <DetailRow label="Total plates" value={quotation.totalPlates} />
                                                                                <DetailRow label="Platform fee" value={formatCurrency(quotation.platformFee)} />
                                                                                <DetailRow label="Delivery fee" value={formatCurrency(quotation.deliveryFee)} />
                                                                            </InvoiceSection>

                                                                            <InvoiceSection title="Vendor">
                                                                                <DetailRow label="Name" value={quotation.vendorName || '-'} />
                                                                                <DetailRow label="City" value={quotation.vendorCity || '-'} />
                                                                                <DetailRow label="State" value={quotation.vendorState || '-'} />
                                                                                <DetailRow label="Address" value={quotation.vendorFullAddress || '-'} />
                                                                                <DetailRow label="Distance" value={quotation.distanceInKm ? `${quotation.distanceInKm} km` : '-'} />
                                                                            </InvoiceSection>

                                                                            <InvoiceSection title="Event">
                                                                                <DetailRow label="Event" value={quotation.event || '-'} />
                                                                                <DetailRow label="Type" value={quotation.eventType || '-'} />
                                                                                <DetailRow label="Date" value={formatDate(quotation.eventDate)} />
                                                                                <DetailRow label="Time" value={quotation.eventTime || '-'} />
                                                                                <DetailRow label="Address" value={quotation.fullAddress || '-'} />
                                                                                <DetailRow label="City" value={quotation.city || '-'} />
                                                                            </InvoiceSection>

                                                                            <InvoiceSection title="Payment">
                                                                                <DetailRow label="Partial paid" value={formatCurrency(quotation.partialAmount)} />
                                                                                <DetailRow label="Remaining" value={formatCurrency(quotation.remainingAmount)} highlight="danger" />
                                                                                <DetailRow label="CGST" value={formatCurrency(quotation.cgstAmount)} />
                                                                                <DetailRow label="SGST" value={formatCurrency(quotation.sgstAmount)} />
                                                                                {quotation.quotationDetails && (
                                                                                    <DetailRow label="Notes" value={quotation.quotationDetails} />
                                                                                )}
                                                                            </InvoiceSection>
                                                                        </div>

                                                                        <div style={grandTotalBarStyle}>
                                                                            <span style={grandTotalLabelStyle}>Grand Total</span>
                                                                            <span style={grandTotalValueStyle}>{formatCurrency(quotation.grandTotal)}</span>
                                                                        </div>

                                                                        {!isAccepted && (
                                                                            <div style={acceptButtonContainerStyle}>
                                                                                <button
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleAcceptQuotation(qId, quotation.vendorName || 'Vendor');
                                                                                    }}
                                                                                    disabled={acceptingQuotation}
                                                                                    style={acceptButtonStyle}
                                                                                    onMouseEnter={(e) => {
                                                                                        if (!acceptingQuotation) {
                                                                                            e.currentTarget.style.background = '#1E7A3D';
                                                                                        }
                                                                                    }}
                                                                                    onMouseLeave={(e) => {
                                                                                        if (!acceptingQuotation) {
                                                                                            e.currentTarget.style.background = '#2F9E5B';
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    {acceptingQuotation ? (
                                                                                        <>
                                                                                            <FaSpinner className="spin" size={14} />
                                                                                            Accepting...
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            <FaCheck size={14} />
                                                                                            Accept Quotation
                                                                                        </>
                                                                                    )}
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};

// ─── Small subcomponents ──────────────────────────────────────────

const InvoiceSection = ({ title, children }) => (
    <div style={quotationSectionStyle}>
        <h4 style={quotationSectionTitleStyle}>{title}</h4>
        {children}
    </div>
);

const DetailRow = ({ label, value, highlight }) => (
    <div style={detailRowStyle}>
        <span style={detailLabelStyle}>{label}</span>
        <span style={{
            ...detailValueStyle,
            color: highlight === 'danger' ? '#B5402C' : detailValueStyle.color,
            fontWeight: highlight === 'danger' ? 700 : detailValueStyle.fontWeight
        }}>{value}</span>
    </div>
);

// ─── Global CSS ──────────────────────────────────────────────────

const globalCss = `
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@600;700&family=Inter:wght@400;500;600;700&display=swap');

    .spin { animation: sq-spin 1s linear infinite; }
    @keyframes sq-spin { to { transform: rotate(360deg); } }
    @keyframes sq-slideDown {
        from { opacity: 0; transform: translateY(-6px); }
        to { opacity: 1; transform: translateY(0); }
    }

    @media (max-width: 900px) {
        .stats-container { grid-template-columns: repeat(3, 1fr) !important; gap: 10px !important; }
        .quotation-grid { grid-template-columns: 1fr 1fr !important; }
    }
    @media (max-width: 680px) {
        .stats-container { grid-template-columns: 1fr 1fr !important; }
        .quotation-grid { grid-template-columns: 1fr !important; }
        .search-filter-container { flex-direction: column; align-items: stretch !important; }
        .card-header { flex-wrap: wrap; gap: 10px; }
        .card-header-right { width: 100%; justify-content: space-between !important; }
        .quotation-header { flex-wrap: wrap; gap: 8px; }
        .quotation-header-right { width: 100%; justify-content: space-between !important; }
    }
    @media (max-width: 420px) {
        .stats-container { grid-template-columns: 1fr !important; }
        .customer-name { font-size: 14px !important; }
        .amount { font-size: 14px !important; }
    }
`;

// ─── Styles ──────────────────────────────────────────────────────

const containerStyle = {
    padding: '4px 2px',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    color: '#241C15',
    height: "65vh",
};

const searchFilterContainerStyle = {
    display: 'flex',
    gap: '12px',
    marginBottom: '18px',
    flexWrap: 'wrap',
    alignItems: 'center',
};

const searchContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minWidth: '180px',
    background: '#fff',
    border: '1px solid #EDE6DB',
    borderRadius: '11px',
    padding: '0 14px',
};

const searchIconStyle = {
    color: '#B5A996',
    marginRight: '10px',
    flexShrink: 0,
};

const searchInputStyle = {
    flex: 1,
    padding: '10px 0',
    border: 'none',
    outline: 'none',
    fontSize: '14px',
    background: 'transparent',
    color: '#241C15',
    fontFamily: "'Inter', sans-serif",
};

const clearSearchButtonStyle = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#B5A996',
    padding: '4px 6px',
    borderRadius: '6px',
};

const statsContainerStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '14px',
    marginBottom: '18px',
};

const statCardStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    background: '#fff',
    padding: '16px 18px',
    borderRadius: '14px',
    border: '1px solid #EDE6DB',
    boxShadow: '0 1px 2px rgba(31,22,15,0.04)',
};

const statIconWrapperStyle = {
    width: '40px',
    height: '40px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
};

const statNumberStyle = {
    fontFamily: "'Poppins', 'Inter', sans-serif",
    fontSize: '20px',
    fontWeight: 700,
    color: '#241C15',
    lineHeight: 1.2,
};

const statLabelStyle = {
    fontSize: '12px',
    color: '#8C7F6E',
    fontWeight: 500,
    marginTop: '1px',
};

// Date Filter Styles
const dateFilterWrapperStyle = {
    display: 'flex',
    alignItems: 'center',
    background: '#fff',
    padding: '0 12px',
    borderRadius: '11px',
    border: '1px solid #EDE6DB',
    flexShrink: 0,
    height: '38px',
};

const dateDropdownStyle = {
    padding: '6px 0',
    border: 'none',
    outline: 'none',
    fontSize: '13px',
    color: '#241C15',
    background: 'transparent',
    fontFamily: "'Inter', sans-serif",
    cursor: 'pointer',
    minWidth: '120px',
};

const customPopupStyle = {
    position: 'absolute',
    top: '46px',
    right: '0',
    background: '#fff',
    borderRadius: '12px',
    border: '1px solid #EDE6DB',
    boxShadow: '0 8px 24px rgba(31,22,15,0.12)',
    zIndex: 100,
    width: '260px',
    padding: '16px',
};

const customPopupHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
};

const popupCloseBtnStyle = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#B5A996',
    padding: '4px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
};

const customPopupBodyStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
};

const customInputGroupStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
};

const customLabelStyle = {
    fontSize: '12px',
    fontWeight: 500,
    color: '#8C7F6E',
};

const customDateInputStyle = {
    padding: '8px 10px',
    border: '1px solid #EDE6DB',
    borderRadius: '8px',
    fontSize: '13px',
    color: '#241C15',
    background: '#fff',
    outline: 'none',
    fontFamily: "'Inter', sans-serif",
    width: '100%',
    cursor: 'pointer',
};

const popupApplyBtnStyle = {
    marginTop: '4px',
    padding: '8px 16px',
    background: '#2F9E5B',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: "'Inter', sans-serif",
    transition: 'background 0.2s',
};

const resultCountStyle = {
    fontSize: '12.5px',
    color: '#8C7F6E',
    fontWeight: 500,
    whiteSpace: 'nowrap',
};

const cardsContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    maxHeight: 'calc(100vh - 360px)',
    paddingRight: '4px',
};

const cardWrapperStyle = {
    flexShrink: 0,
};

const cardOuterStyle = {
    background: '#fff',
    borderRadius: '14px',
    border: '1px solid #EDE6DB',
    overflow: 'hidden',
    transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
};

const cardHeaderStyle = {
    display: 'flex',
    alignItems: 'center',
    padding: '14px 18px 14px 0',
    cursor: 'pointer',
    gap: '14px',
};

const leadAccentStyle = {
    width: '4px',
    alignSelf: 'stretch',
    borderRadius: '0 4px 4px 0',
    minHeight: '44px',
};

const cardHeaderLeftStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '13px',
    flex: 1,
    minWidth: 0,
};

const avatarStyle = {
    width: '38px',
    height: '38px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #E66D33, #C1552A)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '15px',
    fontWeight: 700,
    flexShrink: 0,
    fontFamily: "'Poppins', sans-serif",
};

const customerNameStyle = {
    fontSize: '14.5px',
    fontWeight: 600,
    color: '#241C15',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

const customerDetailStyle = {
    fontSize: '12.5px',
    color: '#8C7F6E',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginTop: '2px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

const dotSeparatorStyle = {
    margin: '0 2px',
    color: '#D9CFC2',
};

const cardHeaderRightStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    flexShrink: 0,
};

const amountStyle = {
    fontFamily: "'Poppins', sans-serif",
    fontSize: '15px',
    fontWeight: 700,
    color: '#1E7A3D',
};

const badgeBaseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 11px',
    borderRadius: '20px',
    fontSize: '11px',
    fontWeight: 600,
};

const expandIconStyle = {
    color: '#B5A996',
    transition: 'transform 0.25s ease',
    display: 'flex',
};

// ─── PAYMENT INFO STYLES ────────────────────────────────────────
const paymentInfoContainerStyle = {
    display: 'flex',
    gap: '24px',
    padding: '8px 18px 12px 22px',
    // background: '#F8F5F0',
    // borderTop: '1px solid #F1EBE1',
};

const paymentInfoRowStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
};

const paymentInfoLabelStyle = {
    fontSize: '12px',
    fontWeight: 500,
    color: '#8C7F6E',
    display: 'flex',
    alignItems: 'center',
};

const paymentInfoValueStyle = {
    fontSize: '13px',
    fontWeight: 700,
    color: '#241C15',
};

// Card body
const cardBodyStyle = {
    padding: '4px 18px 18px 22px',
    borderTop: '1px solid #F1EBE1',
    background: '#FDFBF8',
    animation: 'sq-slideDown 0.25s ease',
};

const bodyLabelStyle = {
    fontSize: '11px',
    fontWeight: 700,
    color: '#B5A996',
    textTransform: 'uppercase',
    letterSpacing: '0.6px',
    margin: '14px 0 10px 0',
};

const loadingQuotationsStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    padding: '26px 20px',
    color: '#8C7F6E',
    fontSize: '13px',
};

const noQuotationsStyle = {
    textAlign: 'center',
    padding: '24px 20px',
    color: '#B5A996',
    fontSize: '13px',
    background: '#fff',
    borderRadius: '10px',
    border: '1px dashed #EDE6DB',
};

const quotationsListStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '9px',
};

const quotationCardStyle = {
    background: '#FFFFFF',
    borderRadius: '11px',
    border: '1px solid #EDE6DB',
    overflow: 'hidden',
    transition: 'border-color 0.2s ease, border-width 0.2s ease',
};

const quotationHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '11px 14px',
    cursor: 'pointer',
};

const quotationHeaderLeftStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '11px',
    flex: 1,
    minWidth: 0,
};

const vendorIconStyle = {
    width: '30px',
    height: '30px',
    borderRadius: '9px',
    background: '#FBEDE4',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#C1552A',
    flexShrink: 0,
};

const vendorNameStyle = {
    fontSize: '13.5px',
    fontWeight: 600,
    color: '#241C15',
};

const quotationMetaStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '3px',
    flexWrap: 'wrap',
};

const quotationDateStyle = {
    fontSize: '11px',
    color: '#B5A996',
};

const quotationHeaderRightStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexShrink: 0,
};

const quotedAmountStyle = {
    fontFamily: "'Poppins', sans-serif",
    fontSize: '14px',
    fontWeight: 700,
    color: '#1E7A3D',
};

// Invoice-styled detail panel
const quotationDetailWrapStyle = {
    borderTop: '1px solid #F1EBE1',
    background: '#FCFAF6',
    animation: 'sq-slideDown 0.25s ease',
};

const perforationStyle = {
    display: 'flex',
    gap: '5px',
    padding: '8px 14px 0 14px',
    overflow: 'hidden',
};

const perfDotStyle = {
    width: '4px',
    height: '4px',
    borderRadius: '50%',
    background: '#E9DFCF',
    flexShrink: 0,
};

const quotationGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '18px',
    padding: '14px 18px',
};

const quotationSectionStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
};

const quotationSectionTitleStyle = {
    fontSize: '11px',
    fontWeight: 700,
    color: '#C1552A',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    margin: '0 0 5px 0',
    paddingBottom: '5px',
    borderBottom: '1px dashed #E9DFCF',
};

const detailRowStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px',
    padding: '1.5px 0',
    fontSize: '12px',
};

const detailLabelStyle = {
    color: '#8C7F6E',
    fontWeight: 500,
    flexShrink: 0,
};

const detailValueStyle = {
    color: '#241C15',
    fontFamily: "'Inter', monospace",
    textAlign: 'right',
};

const grandTotalBarStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0 14px 14px 14px',
    padding: '10px 16px',
    background: 'linear-gradient(135deg, #241C15, #3A2E22)',
    borderRadius: '10px',
};

const grandTotalLabelStyle = {
    fontSize: '11.5px',
    fontWeight: 600,
    color: '#D9CFC2',
    textTransform: 'uppercase',
    letterSpacing: '0.6px',
};

const grandTotalValueStyle = {
    fontFamily: "'Poppins', sans-serif",
    fontSize: '16px',
    fontWeight: 700,
    color: '#FFB784',
};

const acceptButtonContainerStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0 14px 14px 14px',
};

const acceptButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 20px',
    background: '#2F9E5B',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 2px 8px rgba(47, 158, 91, 0.25)',
    fontFamily: "'Inter', sans-serif",
};

// Empty state
const emptyStateStyle = {
    padding: '54px 20px',
    textAlign: 'center',
    background: '#fff',
    borderRadius: '14px',
    border: '1px solid #EDE6DB',
};

const emptyStateContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
};

const emptyStateTextStyle = {
    fontSize: '15px',
    fontWeight: 600,
    color: '#3A2E22',
    margin: '6px 0 0 0',
};

const emptyStateSubtextStyle = {
    fontSize: '12.5px',
    color: '#B5A996',
};

// Loading
const loadingStyle = {
    padding: '54px 20px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    color: '#8C7F6E',
    fontSize: '13px',
};

export default ManagerQuotation;